export const zh = {
  nav_experiences: "体验",
  nav_destinations: "目的地",
  nav_boat: "卡普里与群岛",
  nav_taste: "美食",
  nav_stay: "住宿",
  nav_create: "定制您的体验",
  nav_book: "预订体验",
  sign_in: "登录",
  sign_out: "退出",
  account_greeting: "您好",
  tagline: "发现坎帕尼亚，亲身体验。",
  hero_line1: "生活在这片地中海 ",
  hero_line2: "与火焰相遇的土地上。",
  hero_cta1: "探索体验",
  hero_cta2: "定制您的旅程",
  dim_title: "您想体验什么？",
  dim_sea: "海洋",
  dim_sea_desc: "大海、岛屿、游船、独木舟、海岸与日落。",
  dim_culture: "文化",
  dim_culture_desc: "考古、历史、艺术、古镇与文化遗产。",
  dim_nature: "自然",
  dim_nature_desc: "火山、山脉、步道与户外活动。",
  dim_taste: "美食",
  dim_taste_desc: "葡萄酒、美食、本地特产与饮食传统。",
  explore_title: "探索坎帕尼亚",
  explore_sub: "从坎皮弗莱格瑞到那不勒斯，从岛屿到维苏威火山，从海岸到亚平宁山脉。",
  featured_title: "精选体验",
  featured_sub: "由我们团队精心挑选的最受欢迎的体验。",
  bysea_title: "Flegrea by Sea",
  bysea_sub: "从完全不同的视角看坎帕尼亚。",
  bysea_cta: "探索游船体验",
  taste_title: "Taste Campania",
  taste_sub: "穿越坎帕尼亚风味之旅。",
  taste_cta: "探索美食体验",
  beyond_title: "Beyond the Coast",
  beyond_sub: "发现坎帕尼亚的野性之美。",
  beyond_cta: "探索自然体验",
  create_title: "找不到您想要的？",
  create_sub: "让我们为您量身打造：私人旅行、家庭、情侣、团队、企业、浪漫求婚、美食与大海。",
  create_cta: "创建您的旅程",
  stay_title: "Stay With Us",
  stay_sub: "精选民宿与居所：体验这片土地的 ideal 基地。",
  stay_cta: "探索住宿",
  why_title: "为什么选择 Flegrea Experience？",
  why_1: "我们了解旅游指南之外的这片土地",
  why_2: "真实的体验，而非简单的参观",
  why_3: "小团出行：更多时间，更多关注",
  why_4: "灵活安排：体验为您量身定制",
  why_5: "我们与当地专业人士和机构合作",
  stories_title: "一片值得讲述的土地",
  stories_sub: "神话、火山与帝王：由生活在这里的人讲述弗莱格雷的故事。",
  final_title: "您的坎帕尼亚故事从这里开始",
  final_sub: "选择一个体验，加入您喜欢的元素，或让我们为您量身打造。",
  copy_1: "坎帕尼亚不仅仅是一个目的地。",
  copy_2: "这里有古老的城市、火山地貌、地中海岛屿、隐秘的村庄、山间小径、非凡美食，以及流传数百年的故事。",
  copy_3: "Flegrea Experience 的诞生，就是为了帮您体验这一切。",
  copy_4: "从坎皮弗莱格瑞到那不勒斯，从普罗奇达和伊斯基亚到庞贝，从阿马尔菲海岸到与阿布鲁佐和莫利塞交界的山脉。",
  copy_5: "选择一个体验，加入您的所爱，或让我们为您创造。",
  copy_cta: "发现坎帕尼亚",
  exp_page_title: "体验",
  exp_page_sub: "坎帕尼亚全境精选体验。选择您的体验，或搭配我们的美食附加项目。",
  filter_all: "全部",
  filter_culture: "文化与历史",
  filter_sea: "海洋与岛屿",
  filter_canoe: "独木舟与水上",
  filter_nature: "自然与户外",
  filter_food: "美食",
  filter_wine: "葡萄酒",
  filter_night: "夜间",
  filter_private: "私人定制",
  offer_badge: "-10%",
  launch_offer: "开业优惠 — 原价已划去",
  all_destinations: "所有目的地",
  results: "项体验",
  from: "起",
  per_person: "每人",
  price_note: "价格为参考价，预订时确认。",
  discover: "探索体验",
  the_experience: "体验详情",
  highlights: "亮点",
  included: "包含",
  not_included: "不包含",
  addons_title: "Make It Taste Better",
  addons_sub: "为您的体验增添一抹坎帕尼亚风味。",
  addons_price_each: "每人",
  on_request: "请咨询",
  meet_guide: "您的导游",
  meet_guide_text: "每次体验均由 Flegrea Experience 精选的认证导游和本地专业人士带领。知识造就非凡。",
  good_to_know: "须知",
  gtk_1: "户外活动视天气和海况而定。",
  gtk_2: "集合地点和后勤详情将在预订后告知。",
  gtk_3: "私人体验可按需定制。",
  faq_title: "常见问题",
  faq_q1: "体验提供哪些语言？",
  faq_a1: "所有体验均提供意大利语和英语。其他语言可应要求安排。",
  faq_q2: "如何预订？",
  faq_a2: "通过 WhatsApp 或表单联系我们：我们确认可用性和详情后为您保留体验。此阶段无需在线支付。",
  faq_q3: "可以定制体验吗？",
  faq_a3: "可以。每个体验都可以添加美食附加项目、接送和额外服务，或通过「定制您的体验」从零打造。",
  book_now: "立即预订",
  request_quote: "获取报价",
  duration: "时长",
  group_size: "人数",
  location_label: "地点",
  languages_label: "语言",
  starting_price: "起始价格",
  dest_page_title: "目的地",
  dest_page_sub: "按地域组织的坎帕尼亚：先选地点，再选体验方式。",
  dest_experiences: "此目的地的体验",
  view_destination: "探索",
  boat_page_sub: "从完全不同的视角看坎帕尼亚。",
  boat_departure: "出发地",
  whats_included: "包含内容",
  book_boat: "预订您的海上体验",
  taste_page_sub: "穿越坎帕尼亚风味之旅。",
  make_taste: "Make It Taste Better",
  make_taste_sub: "为您的体验增添一抹坎帕尼亚风味。几乎每个体验都可以加入美食时刻。",
  territories_title: "美食产区",
  stay_page_sub: "不只是酒店：体验土地的理想基地，体验项目触手可及。",
  check_availability: "查询空房",
  rooms_label: "房间",
  services_label: "设施",
  nearby_exp: "附近体验",
  stay_placeholder_note: "精选住宿 — 详情和空房信息正在完善中。",
  step1: "您和谁一起旅行？",
  step2: "多少人？",
  step3: "什么时候？",
  step4: "您喜欢什么？",
  step5: "想去哪里？",
  step6: "想加点特别的吗？",
  step7: "告诉我们更多",
  step8: "联系方式",
  opt_solo: "独自",
  opt_couple: "情侣",
  opt_family: "家庭",
  opt_friends: "朋友",
  opt_group: "团体",
  more_than_10: "超过10人（定制需求）",
  next: "继续",
  back: "返回",
  submit: "创建我的体验",
  thankyou: "谢谢。您的坎帕尼亚之旅从这里开始。",
  thankyou_sub: "我们已收到您的需求，将尽快联系您打造专属体验。",
  thankyou_wa: "通过 WhatsApp 加快沟通",
  name_label: "姓名",
  email_label: "邮箱",
  phone_label: "电话",
  whatsapp_label: "WhatsApp",
  notes_placeholder: "告诉我们您的梦想：特殊场合、节奏、必看景点、特殊需求……",
  footer_experiences: "体验",
  footer_legal: "法律信息",
  footer_contacts: "联系方式",
  footer_follow: "关注我们",
  privacy: "隐私政策",
  cookie: "Cookie",
  terms: "条款与条件",
  wa_float: "规划您的体验",
  wa_message: "您好 Flegrea Experience！我想了解：",
  wa_book_prefix: "您好！我想预订体验：",
  wa_quote_prefix: "您好！我想获取体验的报价：",
  wa_stay_prefix: "您好！我想查询住宿空房：",
  badge_PRIVATE: "私人",
  badge_SMALL_GROUP: "小团",
  badge_SUMMER: "夏季",
  badge_BOAT: "游船",
  badge_FOOD: "美食",
  badge_NATURE: "自然",
  loading: "加载中…",
  not_found: "未找到该体验",
  back_experiences: "所有体验",
  back_destinations: "所有目的地",
  about: "关于我们",
  contact: "联系我们",
  faq: "常见问题",
  nature_word: "自然",
  step_of: "/",
  date_flexible: "我的日期灵活",
  map_hint: "探索地图 — 将鼠标悬停在地点上",
  choose_date: "日期",
  participants: "人数",
  time_slot: "时段",
  slot_morning: "上午",
  slot_afternoon: "下午",
  slot_evening: "晚上",
  addons_label: "附加服务",
  estimated_total: "预估总额",
  send_request: "发送预订请求",
  whatsapp_context: "通过 WhatsApp 预订",
  ask_questions: "有疑问？给我们留言",
  save_experience: "收藏体验",
  saved_favorite: "已收藏",
  removed_favorite: "已取消收藏",
  login_to_save: "登录以收藏和管理您的体验",
  request_sent: "请求已发送",
  request_sent_sub: "我们已收到您的请求，将尽快与您确认可用性和详情。",
  remove: "删除",
  account_title: "我的账户",
  account_signin_sub: "登录以查看您的请求和收藏的体验。",
  my_requests: "我的请求",
  my_experiences: "我的体验",
  no_requests: "您还没有发送任何请求。",
  no_favorites: "您还没有收藏任何体验。",
  discover_experiences: "探索体验",
  custom_request: "定制请求",
  requested_on: "请求日期",
  status_inviata: "已发送请求",
  status_attesa: "等待确认",
  status_confermata: "已确认",
  status_completata: "已完成",
  status_annullata: "已取消",
  cookie_banner_text: "我们使用必要的技术性 Cookie，并仅在您同意后使用分析 Cookie 以改进体验。您可以随时更改选择。",
  cookie_accept_all: "全部接受",
  cookie_reject: "拒绝",
  cookie_customize: "自定义",
  cookie_save_prefs: "保存偏好",
  cookie_necessary: "必要 Cookie（始终启用）",
  cookie_analytics: "分析 Cookie",
  manage_cookies: "管理 Cookie 偏好",
  search_placeholder: "搜索体验或地点…",
  related_title: "您可能也喜欢",
  what_to_bring: "携带物品",
  wtb_1: "舒适的鞋子和一瓶水",
  wtb_2: "海上体验请带泳衣、毛巾和防晒霜",
  wtb_3: "徒步和登山请穿分层衣物",
  boat_hero_note: "私人游览 • 日落 • 开胃酒 • 定制体验",
  boat_hero_sub2: "以完全不同的视角体验那不勒斯的海。",
  discover_experience: "了解体验",
  faq_page_title: "常见问题",
  faq_page_sub: "预订、付款、取消、天气以及您需要了解的一切。",
  need_help: "需要帮助？",
  booking_info: "预订须知",
  cancellation_policy: "取消政策",
  all_faqs: "所有常见问题",
  admin_title: "管理区",
  admin_denied: "访问受限。请使用管理员账户登录。",
  admin_link: "管理面板",
  tab_overview: "概览",
  tab_requests: "请求",
  tab_experiences: "体验",
  tab_users: "用户",
  tab_contacts: "联系消息",
  stats_requests: "请求总数",
  stats_users: "注册用户",
  stats_experiences: "进行中体验",
  stats_favorites: "收藏数",
  change_status: "更改状态",
  featured_label: "精选",
  save_label: "保存",
  saved_ok: "已保存",
  price_edit: "价格（起）",
  day_title: "定制您的坎帕尼亚一日游",
  day_sub: "选择您想体验的内容：我们自动将海洋、文化、美食和自然组合成专属行程。",
  day_pick: "您想体验什么？",
  day_area: "您想去哪里？",
  day_area_all: "坎帕尼亚全境",
  day_people: "多少人？",
  day_generate: "生成我的行程",
  day_itinerary: "您的行程",
  day_morning: "上午",
  day_afternoon: "下午",
  day_evening: "晚上",
  day_empty: "请至少选择两个维度以生成行程。",
  day_send: "申请此行程",
  day_sent_title: "行程已申请",
  day_sent_sub: "我们已收到您的理想行程，将为您制定具体方案并尽快联系您。",
  day_per_person: "每人",
  day_edit: "修改选择",
  nav_companion: "Companion",
  companion_title: "Flegrea Companion",
  companion_sub: "您的旅行伴侣：您将游览之地的读物与故事，以及随时可用的服务与团队支持。",
  langs_note: "即将推出",
  readings_title: "阅读与深入了解",
  min_read: "分钟阅读",
  back_companion: "所有故事",
  your_services: "您的服务",
  support_staff: "团队支持",
  support_title: "需要帮助？",
  support_sub: "一切自主管理 — 需要时，我们的团队只需一条消息。",
  carousel_overline: "这片土地",
  carousel_title: "真实的坎帕尼亚",
  carousel_sub: "来自我们旅程的真实照片。即将推出：考古遗址与游船之旅的航拍视频。",
  contact_title: "咨询信息",
  contact_sub: "简单、快速、简洁：给我们留言，我们直接通过邮件回复。",
  message_label: "您的留言",
  send_message: "发送请求",
  contact_sent: "留言已发送",
  contact_sent_sub: "谢谢！我们将尽快回复您提供的邮箱地址。",
  contact_required: "请填写姓名、邮箱和留言。",
  contact_error: "发送失败。请重试或通过 WhatsApp 联系我们。",
  contact_privacy_note: "发送即表示您接受隐私政策。留言将直接发送至 info@flegreaexperience.com。",
  pay_online: "在线支付",
  pay_online_note: "Stripe 安全支付。可用性以最终确认为准。",
  payment_processing: "正在验证您的支付…",
  payment_success_title: "支付成功",
  payment_success_sub: "谢谢！您的请求已在支付端确认。我们将联系您确认可用性和体验详情。",
  payment_success_pending_note: "如果您已完成支付，确认可能需要几分钟。如有疑问请通过 WhatsApp 联系我们。",
  payment_check_again: "验证中",
  payment_cancel_title: "支付已取消",
  payment_cancel_sub: "未产生任何扣款。您可以随时重试，或发送不含在线支付的请求。",
  nav_all_experiences: "所有体验",
  nav_gallery: "画廊",
  gallery_title: "画廊",
  gallery_sub: "我们体验中的所有地点，一帧一帧呈现：从弗莱格雷的火山到岛屿，从那不勒斯地下城到索伦托的柠檬。",
  gallery_videos_title: "动感土地",
  gallery_videos_sub: "来自海上与陆地的影像。更多视频——无人机航拍与体验故事——即将上线。",
  gallery_coming_soon: "即将上线",
  gallery_photos_title: "全部照片",
  back_home: "返回首页",
  hero_sub: "在弗莱格雷地区体验旅行、徒步、大海、历史与地道风味。",
  story_cta: "了解故事",
  seo_home_title: "Flegrea Experience — 弗莱格雷地区旅行与体验",
  seo_home_desc: "在弗莱格雷地区的真实体验：波佐利、巴亚、巴科利导览，阿韦尔诺湖与新山，卡普里、伊斯基亚、普罗奇达游船。",
  boat_cta_title: "准备启航了吗？",
  boat_cta_sub: "通过 WhatsApp 联系我们，规划您在弗莱格雷地区的海上的一天。",
};
